import React from 'react';
import { useContext, useEffect } from 'react';
import { createContext } from 'react';
import useNetlifyIdentity from './src/functions/useNetlifyIdentity';

const defaultState = {
  data: {},
}

export const MyBrain = createContext(defaultState)
export const MyBrainProvider = ({ children }) => {



  const {
    authReady,
    user,
    error,
    login,
    logout,
    loginFailed,
    JWT
  } = useNetlifyIdentity()

  // const authReady = true

  const contextValues = {


    authReady,
    user,
    error,
    login,
    logout,
    loginFailed,
    JWT


  }

  return <MyBrain.Provider value={contextValues}>{children}</MyBrain.Provider>
}

export const useBrain = () => {
  const context = useContext(MyBrain)
  if (context === undefined || context === null) {
    throw new Error('useBrain must be called within Provider')
  }
  return context
}
